<template>
  <section>
    <div
      ref="heroContainerRef"
      class="tw:flex tw:w-full tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:sm:max-w-[560px] tw:max-w-[560px] tw:px-8 tw:md:px-0 tw:pt-6 tw:md:pt-9 tw:mx-auto tw:lg:pt-8 tw:min-h-[560px] tw:md:min-h-[340px] tw:lg:min-h-[478px] tw:overflow-hidden"
    >
      <div
        class="tw:flex tw:items-start tw:md:items-center tw:relative tw:flex-col tw:md:flex-row tw:justify-start tw:md:justify-between tw:w-full"
      >
        <div
          ref="textBoxRef"
          class="tw:flex tw:flex-col tw:lg:w-1/2 tw:md:w-full tw:md:max-w-[401px] tw:lg:max-w-[50%] tw:max-w-full tw:w-full tw:items-center tw:md:items-start tw:pb-8 tw:lg:mb-0 tw:md:mr-[20px] tw:mr-0"
        >
          <h1
            class="tw:pr-2 tw:lg:text-header-big tw:md:text-2xl tw:text-medium tw:font-bold tw:mb-2 tw:md:mb-4 tw:md:text-left tw:text-center"
            v-html="$t('rc_mp_header')"
          />
          <p class="tw:text-xs tw:md:text-sm tw:lg:text-lg tw:md:text-left tw:text-center">{{ $t('rc_mp_subtext') }}</p>
          <MainButton @click="onLoginClick" class="tw:lg:flex tw:hidden tw:mt-10">{{
            $t('check_out_page_rc_cta')
          }}</MainButton>
          <MainButton @click="onLoginClick" size="medium" class="tw:flex tw:lg:hidden tw:mt-4">{{
            $t('check_out_page_rc_cta')
          }}</MainButton>
        </div>
        <div
          class="tw:flex tw:items-center tw:justify-center tw:md:justify-end tw:w-auto tw:lg:w-1/2 tw:md:absolute tw:bottom-0 tw:md:bottom-0 tw:lg:-bottom-0 tw:md:right-0 tw:md:ml-auto tw:mx-auto"
        >
          <video
            ref="videoRef"
            autoplay
            muted
            loop
            playsinline
            :src="heroVideo"
            class="tw:w-full tw:h-auto tw:max-w-[320px] tw:md:max-w-none tw:md:h-[250px] tw:lg:h-[413px] tw:block"
            @click="togglePlay"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { computed, ref } from 'vue'

import MainButton from '@/components/base/buttons/MainButton.vue'

import { useSessionValues } from '@/composables/useSessionValues'

import appAnalytics from '@/utils/tracking'

import defaultStudioPlusHeroVideo from '@/assets/videos/rate-connect-landing/hero/RC_US.mp4'
import studioPlusHeroVideoDe from '@/assets/videos/rate-connect-landing/hero/RC_DE.mp4'
import studioPlusHeroVideoGr from '@/assets/videos/rate-connect-landing/hero/RC_GR.mp4'
import studioPlusHeroVideoGb from '@/assets/videos/rate-connect-landing/hero/RC_UK.mp4'
import studioPlusHeroVideoEsEs from '@/assets/videos/rate-connect-landing/hero/RC_ES.mp4'
import studioPlusHeroVideoEsMx from '@/assets/videos/rate-connect-landing/hero/RC_MX.mp4'
import studioPlusHeroVideoFr from '@/assets/videos/rate-connect-landing/hero/RC_FR.mp4'
import studioPlusHeroVideoIt from '@/assets/videos/rate-connect-landing/hero/RC_IT.mp4'
import studioPlusHeroVideoJp from '@/assets/videos/rate-connect-landing/hero/RC_JA.mp4'
import studioPlusHeroVideoNl from '@/assets/videos/rate-connect-landing/hero/RC_NL.mp4'
import studioPlusHeroVideoPl from '@/assets/videos/rate-connect-landing/hero/RC_PL.mp4'
import studioPlusHeroVideoPtBr from '@/assets/videos/rate-connect-landing/hero/RC_BR.mp4'
import studioPlusHeroVideoPtPt from '@/assets/videos/rate-connect-landing/hero/RC_PT.mp4'
import studioPlusHeroVideoTr from '@/assets/videos/rate-connect-landing/hero/RC_TR.mp4'

const { language } = useSessionValues()
const emit = defineEmits(['onLoginClick'])
const onLoginClick = e => {
  appAnalytics.track(appAnalytics.events.LP_RATE_CONNECT_START_CAMPAIGN_CLICKED)
  emit('onLoginClick', e.target.value)
}

const videoRef = ref(null)

const rateConnectHeroVideosByLocale = {
  'en-US': defaultStudioPlusHeroVideo,
  'de-DE': studioPlusHeroVideoDe,
  'el-GR': studioPlusHeroVideoGr,
  'en-GB': studioPlusHeroVideoGb,
  'es-ES': studioPlusHeroVideoEsEs,
  'es-MX': studioPlusHeroVideoEsMx,
  'fr-FR': studioPlusHeroVideoFr,
  'it-IT': studioPlusHeroVideoIt,
  'ja-JP': studioPlusHeroVideoJp,
  'nl-NL': studioPlusHeroVideoNl,
  'pl-PL': studioPlusHeroVideoPl,
  'pt-BR': studioPlusHeroVideoPtBr,
  'pt-PT': studioPlusHeroVideoPtPt,
  'tr-TR': studioPlusHeroVideoTr,
}

const heroVideo = computed(() => {
  const locale = language.value

  if (rateConnectHeroVideosByLocale[locale]) {
    return rateConnectHeroVideosByLocale[locale]
  }

  return defaultStudioPlusHeroVideo
})

const togglePlay = () => {
  if (!videoRef.value) return
  videoRef.value.paused ? videoRef.value.play() : videoRef.value.pause()
}
</script>
